export const COIN_TO_USD_PRECISION: Record<string, number> = {
  BTC: 1,
  ETH: 1,
  LTC: 2,
  XRP: 4,
};

export const COIN_TO_BTC_PRECISION: Record<string, number> = {
  BTC: 0,
  ETH: 5,
  LTC: 6,
  XRP: 8,
};
